import { ulid } from "ulid";
export const ULID_BODY = /^[0-9A-HJKMNP-TV-Z]{26}$/;
/** Generate a new namespaced ULID, e.g. `rec_01H8XYZA0BC1D2E3F4G5H6J7K8`. */
export function newId(namespace) {
    if (!/^[a-z]{2,8}$/.test(namespace)) {
        throw new Error(`Invalid namespace: ${namespace}`);
    }
    return `${namespace}_${ulid()}`;
}
/** Validate that a string is a namespaced ULID. */
export function isValidUlid(value) {
    const match = /^([a-z]{2,8})_(.+)$/.exec(value);
    if (!match)
        return false;
    return ULID_BODY.test(match[2]);
}
//# sourceMappingURL=ulid.js.map